import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
interface Step {
  id: string | number;
  label: string;
  description?: string;
}
interface StepIndicatorProps {
  steps: Step[];
  currentStep: number; // 0-based index
  className?: string;
  orientation?: 'horizontal' | 'vertical';
}
export function StepIndicator({
  steps,
  currentStep,
  className = '',
  orientation = 'horizontal'
}: StepIndicatorProps) {
  return <div className={`${className} ${orientation === 'vertical' ? 'flex flex-col gap-0' : 'flex items-center justify-between w-full'}`} data-id="element-5443">
      {steps.map((step, index) => {
      const isCompleted = index < currentStep;
      const isCurrent = index === currentStep;
      const isPending = index > currentStep;
      return <div key={step.id} className={`relative flex ${orientation === 'vertical' ? 'flex-row pb-8 last:pb-0' : 'flex-col items-center flex-1'}`} data-id="element-5444">
            {/* Connector Line */}
            {index < steps.length - 1 && <div className={`absolute ${orientation === 'vertical' ? 'left-4 top-8 bottom-0 w-0.5 ml-[-1px]' : 'top-4 left-[50%] right-[-50%] h-0.5 mt-[-1px]'} bg-gray-200 z-0`} data-id="element-5445">
                <motion.div initial={{
            scaleY: 0,
            originY: 0
          }} animate={{
            scaleY: isCompleted ? 1 : 0,
            scaleX: orientation === 'horizontal' && isCompleted ? 1 : 0
          }} transition={{
            duration: 0.5,
            delay: 0.2
          }} className={`w-full h-full bg-primary-500 origin-top`} data-id="element-5446" />
              </div>}

            {/* Step Circle */}
            <div className={`relative z-10 flex items-center justify-center w-8 h-8 rounded-full border-2 transition-all duration-300 ${isCompleted ? 'bg-primary-500 border-primary-500 text-white' : isCurrent ? 'bg-white border-primary-500 text-primary-500 ring-4 ring-primary-50' : 'bg-white border-gray-200 text-gray-400'}`} data-id="element-5447">
              {isCompleted ? <Check className="w-4 h-4" data-id="element-5448" /> : <span className="text-xs font-bold" data-id="element-5449">{index + 1}</span>}
            </div>

            {/* Label */}
            <div className={`${orientation === 'vertical' ? 'ml-4 pt-1' : 'mt-3 text-center'}`} data-id="element-5450">
              <p className={`text-sm font-bold transition-colors duration-300 ${isCurrent || isCompleted ? 'text-charcoal-900' : 'text-gray-400'}`} data-id="element-5451">
                {step.label}
              </p>
              {step.description && <p className="text-xs text-gray-500 mt-0.5 hidden sm:block" data-id="element-5452">
                  {step.description}
                </p>}
            </div>
          </div>;
    })}
    </div>;
}